export enum AnalyticsNamespace {
  SIP_CLIENT = 'sipc',
  VOICEMAIL = 'vm',
  FAXING = 'fax',
  CONTACTS = 'contacts',
  CALL_ANALYTICS = 'ca',
  WEB_PHONE = 'wp',
  MESSAGING = 'msg',
  AUTHENTICATION = 'auth',
  SHARED = 'shared',
  WEB_SOCKET = 'ws',
  MISSED_CALLS = 'mc',
  DESKTOP = 'desktop',
}
